/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import './styles.less';

export const DataGridDownloadButton = () => {
	return <div className="data-grid__download-button" />;
};
